import { c as _c } from "react/compiler-runtime";
import { Stack, styled } from '@mui/material';
import { Provider, type BackupJob, type InventoryResource, type ResourceType, type RestoreJob } from '@repo/api-gw-sdk';
import type { ReactNode } from 'react';
import { CloudProviders } from '@/assets/logos/cloudProviders';
import { ResourceTypes } from '@/data/inventory/resourceTypes';
import { isJob } from './queryBuilder/jobTypeGuards';
import { CircleImage } from './shared/circleImage';
import { OverflowTooltip } from './tooltips/overflowTooltip';
export const CloudProviderIndicator = styled(({
  cloudProvider,
  text,
  className
}: {
  cloudProvider: Provider;
  text?: ReactNode;
  className?: string;
}) => {
  return <Stack direction='row' className={className} sx={{
    alignItems: 'center',
    gap: '12px'
  }}>
        <CloudProviderCircle cloudProvider={cloudProvider} />
        {!text || typeof text === 'string' ? <OverflowTooltip text={text as string || CloudProviders[cloudProvider]?.displayName || cloudProvider} /> : text}
      </Stack>;
})({});
export const CloudProviderCircle = t0 => {
  const $ = _c(2);
  const {
    cloudProvider
  } = t0;
  let t1;
  if ($[0] !== cloudProvider) {
    t1 = CloudProviders[cloudProvider] && <CircleImage className="circle-image" alt={CloudProviders[cloudProvider]?.displayName} src={CloudProviders[cloudProvider]?.logo} srcDark={CloudProviders[cloudProvider]?.logoDark} />;
    $[0] = cloudProvider;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const ResourceTypeIndicator = t0 => {
  const $ = _c(3);
  const {
    resourceType
  } = t0;
  const cloudProvider = ResourceTypes[resourceType]?.provider;
  const t1 = ResourceTypes[resourceType]?.displayName;
  let t2;
  if ($[0] !== cloudProvider || $[1] !== t1) {
    t2 = <CloudProviderIndicator cloudProvider={cloudProvider} text={t1} />;
    $[0] = cloudProvider;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const getCloudProvider = (entity: InventoryResource | RestoreJob | BackupJob): Provider => {
  return isJob(entity) ? entity.resourceDetails?.cloudProvider || Provider.ProviderUnspecified : entity.cloudProvider;
};